import FieldUsers from "../../../generic/users/users"

import FieldConfig from "../../../proto/field-config"
import Task from "../../../../model2/task/task"
import FieldTaskReportedByUsers_TableCell from "./render/table/table-cell"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types"

export default class FieldTaskReportedByUsers extends FieldUsers {

    constructor(config: FieldConfig) {
        super(config)

        this.icon       = 'i5-users'
        this.label      = 'Reported by users'

        this.hasCalculatedValues                    = true
        this.renderComponents.tableCell             = FieldTaskReportedByUsers_TableCell
        this.renderComponents.tableCellCalculated   = FieldTaskReportedByUsers_TableCell
    }

    canEdit(model: Task): boolean {
        return false
    }

    getDefaultAggregateFunction(): AggregateFunctionType {
        return AggregateFunctionType.USERS_UNION
    }
}
